import React from "react";
import { Box, Typography, Container, Grid2 } from "@mui/material";
import "./salesforceBackbone.scss";

const SalesforceBackbone = () => {
  return (
    <div className="sb-wrapper">
      <Container>
        <Grid2 className="sbfbox">
          <Grid2 className="sbf1">
            <h4>Salesforce As The Backbone Of BFSI Transformation </h4>
            <p>The top BFSI trends In 2026 Clearly Indicate A <br /> Shift Toward Intelligent, Connected, And <br /> Customer-Centric Financial Services. </p>
            <p className="pt">With Salesforce, Organizations Can: </p>
          </Grid2>
          <Grid2 className="sbf2">
            <img src="/images/salesf.png" alt="" />
          </Grid2>

        </Grid2>
        
        <Grid2 className="sbsbox">
          
          <Grid2 className="inb">
            <div className="avtarbox"><img src="/images/rock.svg" alt="" /></div>
            <p>Accelerate Digital Transformation in <br /> Banking  </p>
          </Grid2>
          <Grid2 className="inb">
             <div className="avtarbox"><img src="/images/shi.svg" alt="" /></div>
             <p>Ensure Security And Compliance   </p>
          </Grid2>
          <Grid2 className="inb">
             <div className="avtarbox"><img src="/images/aib.svg" alt="" /></div>
             <p>Deliver AI-driven Customer <br /> Experiences </p>
          </Grid2>
          <Grid2 className="inb">
             <div className="avtarbox"><img src="/images/eos.svg" alt="" /></div>
             <p>Build Scalable, Future-Ready <br /> Ecosystems  </p>
          </Grid2>
          <Grid2 className="inb">
             <div className="avtarbox"><img src="/images/setting.svg" alt="" /></div>
             <p>Improve Operational <br /> Efficiency  </p>
          </Grid2>
          
          </Grid2>  
         
      </Container>
       <Grid2 className="endblack">
        <Grid2 className="en">
          <p className="pa">Intelligent. Connected .Trusted.</p>
        <p className="pa">Transform BFSI With <span>Salesforce</span></p>
        </Grid2>
            </Grid2>      
    </div>
  );
};

export default SalesforceBackbone;
